import { render } from "./DeleteProgramForm.vue?vue&type=template&id=0f0521ea"
import script from "./DeleteProgramForm.vue?vue&type=script&lang=js"
export * from "./DeleteProgramForm.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__